import { Button } from '@/components/ui/button';
import Modal from '@/components/ui/modal';
import { useTranslations } from 'next-intl';

interface ConfirmationCloseModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSaveAndClose: () => void;
    onCloseWithoutSaving: () => void;
}

export default function ConfirmationCloseModal({
    isOpen,
    onClose,
    onSaveAndClose,
    onCloseWithoutSaving,
}: ConfirmationCloseModalProps) {
    const t = useTranslations();

    return (
        <Modal
            closePosition="top-[20px] right-[20px]"
            bg="bg-[#0E0E0E]"
            ModalSize="max-w-[545px]"
            isOpen={isOpen}
            onClose={onClose}
            modalPadding="p-[30px]"
        >
            <div className="flex flex-col items-center gap-6 mt-[20px]">
                <div className="text-center text-[24px] font-semibold">
                    {t('ScreeningRoom.modal.confirmation.closeWithChanges.title')}
                </div>
                <div className="flex justify-center gap-[20px] mb-[10px] w-full">
                    <Button
                        onClick={onCloseWithoutSaving}
                        className="cursor-pointer px-[30px]! h-[52px] bg-[#DD06AE] hover:bg-[#B10DCE] text-white"
                    >
                        {t('ScreeningRoom.modal.confirmation.closeWithChanges.no')}
                    </Button>
                    <Button
                        onClick={onSaveAndClose}
                        className="cursor-pointer px-[30px]! h-[52px] bg-[#DD06AE] hover:bg-[#B10DCE] text-white"
                    >
                        {t('ScreeningRoom.modal.confirmation.closeWithChanges.yes')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
